import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon, Button, OverlayTrigger, Tooltip } from '@bingads-webui-react/primitive';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { getMenuItemStyles } from '../styles/menu-item-styles';
import { GetNodeClassNames } from '../helpers/node-helper';

const StaticItem = ({
  classes,
  node,
  renderText,
  onItemClick,
  permissions,
}) => {
  const isNavRefresh = isNavigationRefreshOn(permissions);
  const cnames = classNames([GetNodeClassNames(node, classes, isNavRefresh)]);

  return (
    <OverlayTrigger
      key="top"
      placement="top"
      overlay={
        <Tooltip id="tooltip-top">
          {node.Name}
        </Tooltip>
      }
    >
      <Button
        key={node.Id}
        className={cnames}
        btnStyle="command"
        onClick={() => onItemClick(node)}
        aria-label={node.Name}
      >
        {node.isSelected && <div className={classes.beforeIcon} />}
        <div className={classNames(classes.iconContainer, isNavRefresh ? '' : classes.whiteText)}>
          <Glyphicon
            id={`${node.glyphIconName}-icon`}
            className={classes.typeSelectionIcon}
            glyph={node.glyphIconName}
          />
        </div>
        {renderText && <span className={classNames(classes.textContainer, 'type-name', isNavRefresh ? '' : classes.whiteText)}>{renderText}</span>}
      </Button>
    </OverlayTrigger>
  );
};

StaticItem.defaultProps = {
  renderText: null,
};

StaticItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  node: PropTypes.shape({
    Id: PropTypes.string,
    Name: PropTypes.string,
    glyphIconName: PropTypes.string,
    isSelected: PropTypes.bool,
  }).isRequired,
  renderText: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

export default withPermissions(withDefaultStyles(StaticItem, getMenuItemStyles));
